export const PURPOSE_TYPE = 'Cash to Close';

export const EVENT = {
    PaymentMethodSelected:  'Client Payment Method Selected',
    RequestStarted:         'Client Request Started',
    MppSkipped:             'Client MPP Skipped',
    MppPurchased:           'Client MPP Purchased',
    MppCancelled:           'Client MPP Cancelled',
    TransferAmountSelected: 'Client Transfer Amount Selected',
    BankInformationViewed:  'Client Bank Information Viewed',
    PdfDownloaded:          'Client PDF Downloaded',
};
